export default __webpack_public_path__ + "static/whatIsAd-bfbb668b9b5685e014ec10b1bf2ebe9a.webp";